import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { socialAccounts } from '@/mocks/home';

export default function SocialMatrix() {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (id: string, handle: string) => {
    try {
      await navigator.clipboard.writeText(handle);
    } catch {
      // clipboard may be unavailable; still surface feedback
    }
    setCopied(id);
    window.setTimeout(() => setCopied(null), 1800);
  };

  return (
    <section id="matrix" className="scroll-mt-24 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="01"
            eyebrow="SOCIAL MATRIX"
            title="黑料官方社交矩阵"
            description="四个官方渠道，分工各不相同。挑一个你最常用的方式关注，之后就不必来回切换着找更新了。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:mt-16 md:grid-cols-2 md:gap-6">
          {socialAccounts.map((account, index) => (
            <Reveal key={account.id} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 md:p-7">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-center gap-4">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                      <i className={`${account.icon} text-2xl`}></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-lg font-semibold text-foreground-950">
                        {account.name}
                      </h3>
                      <p className="mt-1 text-xs text-foreground-500">{account.platform}</p>
                    </div>
                  </div>
                  <span className="flex shrink-0 items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                    <i className="ri-verified-badge-line text-sm"></i>
                    已认证
                  </span>
                </div>

                <div className="mt-5 flex items-baseline gap-2">
                  <span className="font-heading text-2xl font-bold text-primary-600">
                    {account.followers}
                  </span>
                  <span className="text-xs text-foreground-500">{account.followersLabel}</span>
                </div>

                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">
                  {account.desc}
                </p>

                <div className="mt-6 flex flex-wrap items-center gap-3 border-t border-background-200 pt-5">
                  <a
                    href="#feed"
                    className="flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
                  >
                    <i className={`${account.icon} text-base`}></i>
                    {account.actionLabel}
                  </a>
                  <button
                    type="button"
                    onClick={() => handleCopy(account.id, account.handle)}
                    className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200"
                  >
                    <i className={copied === account.id ? 'ri-check-line text-base' : 'ri-file-copy-line text-base'}></i>
                    {copied === account.id ? '已复制' : account.handle}
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}